var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "account icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 29,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.2%",
    y: "-1.7%",
    width: "108.3%",
    height: "106.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.278431373   0 0 0 0 0.31372549   0 0 0 0 0.419607843  0 0 0 0.25543597 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Auth,-Account-+-Help",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Current-model---managed-by-district",
    transform: "translate(-340.000000, -239.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "welcome-banner-copy",
    transform: "translate(324.000000, 223.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "account-icon",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Mask",
    fill: "#DFE1E7",
    cx: 28,
    cy: 28,
    r: 28
  }), /*#__PURE__*/React.createElement("g", {
    id: "form-icon",
    transform: "translate(12.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-2",
    transform: "translate(12.747712, 16.122366) rotate(-6.000000) translate(-12.747712, -16.122366) translate(1.747712, 1.622366)",
    fill: "#9EA3B7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 21.2571429,
    height: 28.1982691,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "document-1",
    transform: "translate(6.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#C6C9D5",
    x: 3.16666667,
    y: 5.42121212,
    width: 6.11111111,
    height: 3.39393939,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    stroke: "#C6C9D5",
    x: 12.0555556,
    y: 5.42121212,
    width: 8.77777778,
    height: 3.39393939,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#DFE1E7",
    x: 2.66666667,
    y: 14.0606061,
    width: 18.6666667,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0909090909,18.3666667 L15.9090909,18.3666667 L15.9090909,18.3666667 L0.0909090909,18.3666667 L0.0909090909,18.3666667 Z",
    id: "Rectangle",
    fill: "#DFE1E7",
    transform: "translate(8.000000, 18.366667) rotate(90.000000) translate(-8.000000, -18.366667) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#DFE1E7",
    x: 2.66666667,
    y: 17.1363636,
    width: 18.6666667,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-31",
    fill: "#DFE1E7",
    x: 2.66666667,
    y: 2.63636364,
    width: 18.6666667,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#DFE1E7",
    x: 2.66666667,
    y: 20.2121212,
    width: 18.6666667,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#DFE1E7",
    x: 2.66666667,
    y: 23.2878788,
    width: 18.6666667,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-20",
    stroke: "#C6C9D5",
    x: 3.16666667,
    y: 11.0454545,
    width: 17.6666667,
    height: 14.8181818,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "lock-24px",
    transform: "translate(14.835476, 15.894610)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0.164524189 0.105389636 19.1645242 0.105389636 19.1645242 19.1053896 0.164524189 19.1053896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5395242,5.7720563 L13.7270242,5.7720563 L13.7270242,4.15300868 C13.7270242,1.91872297 11.9070242,0.105389636 9.66452419,0.105389636 C7.42202419,0.105389636 5.60202419,1.91872297 5.60202419,4.15300868 L5.60202419,5.7720563 L4.78952419,5.7720563 C3.89577419,5.7720563 3.16452419,6.50062773 3.16452419,7.39110392 L3.16452419,15.486342 C3.16452419,16.3768182 3.89577419,17.1053896 4.78952419,17.1053896 L14.5395242,17.1053896 C15.4332742,17.1053896 16.1645242,16.3768182 16.1645242,15.486342 L16.1645242,7.39110392 C16.1645242,6.50062773 15.4332742,5.7720563 14.5395242,5.7720563 Z M9.66452419,13.0577706 C8.77077419,13.0577706 8.03952419,12.3291992 8.03952419,11.438723 C8.03952419,10.5482468 8.77077419,9.81967535 9.66452419,9.81967535 C10.5582742,9.81967535 11.2895242,10.5482468 11.2895242,11.438723 C11.2895242,12.3291992 10.5582742,13.0577706 9.66452419,13.0577706 Z M12.1832742,5.7720563 L7.14577419,5.7720563 L7.14577419,4.15300868 C7.14577419,2.76872297 8.27514919,1.64348487 9.66452419,1.64348487 C11.0538992,1.64348487 12.1832742,2.76872297 12.1832742,4.15300868 L12.1832742,5.7720563 Z",
    id: "Shape",
    fill: "#47506B"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account-icon.3f5050afec50050d8c3851c17985d074.svg";
export { ForwardRef as ReactComponent };